<template>
  <a-table
    :columns="columns"
    :data-source="tableData"
    :pagination="pagination"
    :row-key="record => record.deviceId"
    :loading="loading"
    @change="handlePagination"
  >
  </a-table>
</template>
<script>
import { Component, Vue, Prop } from 'vue-property-decorator';
import { entryOrLeaveDetails } from '@/services/smart-hat/screen';
import { shareEntryOrLeaveDetails } from '@/services/smart-hat/screen-share';

@Component()
export default class DialogPersonOffline extends Vue {
  pagination = {
    current: 1,
    pageSize: 10,
    total: 0,
    showQuickJumper: true,
    showSizeChanger: true,
    pageSizeOptions: ['10', '20', '50', '100'],
    showTotal: total => this.$t('todo.flow.total', { total }),
  };
  loading = false;
  tableData = [];
  get columns() {
    const list = [
      {
        align: 'left',
        title: '日期',
        dataIndex: 'startTime',
        ellipsis: true,
        customRender: text =>
          text ? this.$moment(text).format('YYYY-MM-DD') : '',
      },
      {
        title: '累计离场次数',
        dataIndex: 'leaveFrequency',
        ellipsis: true,
      },
      {
        title: '累计离场时长',
        dataIndex: 'leaveDuration',
        ellipsis: true,
        customRender: text => (text === 0 || text > 0 ? text + '小时' : '-'),
      },
    ];
    if (!this.hasShare) {
      list.push({
        title: this.$t('enterpriseManagement.camera.tableColumn.operation'),
        fixed: 'right',
        key: 'operation',
        ellipsis: true,
        customRender: (_, record) => (
          <span
            style={{
              color: 'var(--font-active)',
              cursor: 'pointer',
            }}
            onClick={() => this.handleDeviceItem(record)}
          >
            详情
          </span>
        ),
      });
    }
    return list;
  }
  @Prop({ type: String }) dayEnum;
  @Prop({ type: String }) id;
  @Prop({ type: Object }) shareParams;
  @Prop({ type: Boolean }) hasShare;
  async getData() {
    this.loading = true;
    try {
      const params = {
        searchDayEnum: this.dayEnum,
        userId: this.id,
        current: this.pagination.current,
        size: this.pagination.pageSize,
      };
      const { records, total } = this.hasShare
        ? await shareEntryOrLeaveDetails(params, this.shareParams)
        : await entryOrLeaveDetails(params);
      this.tableData = records;
      this.pagination.total = total;
      // eslint-disable-next-line no-empty
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
  handleDeviceItem(item) {
    const route = this.$router.resolve({
      path: `/hat/clock?key=2&userId=${item.userId}&date=${this.dayEnum}`,
    });
    window.open(route.href, '_blank');
  }
  handlePagination(data) {
    this.pagination = data;
    this.getData();
  }
  mounted() {
    this.getData();
  }
}
</script>
<style lang="less" module></style>
